export const ImgApi = "https://cdn.jsdelivr.net/gh/naseeihity/imageHosting";
export const Folder = "origin";
